import React from "react"
import tw, { styled, css } from "twin.macro"

interface Props {
  // Is the enrol button hidden?
  hideEnrolButton?: boolean
  // Event handler when the button is clicked
  enrolButtonClicked?: () => void
}

const BottomBar: React.SFC<Props> = ({
  hideEnrolButton,
  enrolButtonClicked,
}) => {
  return (
    <div
      css={[
        tw`transition-opacity duration-200 md:hidden`,
        hideEnrolButton && tw`opacity-0`,
      ]}
    >
      <BottomBarWrapper>
        <Button onClick={enrolButtonClicked}>Enrol</Button>
      </BottomBarWrapper>
    </div>
  )
}

// Div positioned at the bottom of the screen with a black to alpha gradient
// along the top edge
const BottomBarWrapper = styled.div`
  ${tw`fixed bottom-0 z-10 w-full flex flex-row justify-center`},
`

const Button = styled.button`
  padding: 0.161rem 0;
  font-family: Interstate;
  ${tw`text-3xl bg-brand-yellow text-black px-4 w-full uppercase focus:outline-none hover:text-black hover:bg-white`}
`

export default BottomBar
